import { firebaseAuth } from '../firebase';
import * as authActions from './actions';


export { authActions };
export * from './action-types';
export { authReducer } from './reducer';
export { getAuth, isAuthenticated, getAuthEmail, getAuthId, getAuthExistsInFirebase } from './selectors';


export function initAuth(dispatch) {
  return new Promise((resolve, reject) => {
    const unsub = firebaseAuth.onAuthStateChanged(
      user => {
        dispatch(authActions.initAuthAndLoadStudents(user))
          .then(() => {
            unsub();
            resolve();
          })
      },
      error => reject(error)
    );
  });
}



// WEBPACK FOOTER //
// ./src/core/auth/index.js